import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html'
})
export class TimeInputComponent implements OnInit {
  formElement!: FormGroup;
  minTime = { hours: "9", minutes: "20" };
  maxTime = { hours: "18", minutes: "40" };
  time2 = { hours: "9", minutes: "10" };
  minTime4 = { hours: "9", minutes: "20" };
  maxTime4 = { hours: "18", minutes: "40" };
  time4 = { hours: "6", minutes: "10" };
  isBrowser = true;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }
  requiredValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value.hours && !control.value.minutes) {
      return { required: true };
    }
    return null;
  };
  minValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (parseInt(control.value.hours) < parseInt(this.minTime4.hours) || (parseInt(control.value.hours) === parseInt(this.minTime4.hours) && parseInt(control.value.minutes) < parseInt(this.minTime4.minutes))) {
      return { minError: true };
    }
    return null;
  };
  ngOnInit(): void {
    this.formElement = this.formBuilder.group({
      inputVal: [''],
      timeDisableInput: [''],
      timeErrorInput: ['', [this.requiredValidator]],
      timeErrorInput1: ['', [this.minValidator]]
    });
    this._activatedRoute.queryParams.subscribe(param => {
      if (param['noJsInput']) {
        this.time2.hours = (param['noJsInput'][0]);
        this.time2.minutes = (param['noJsInput'][1]);
      }
    });
  }

  submit() {
    this.submitted = true;
  }
}